import i18next from 'i18next';
import moment from 'moment';
import { initReactI18next } from 'react-i18next';
import { translation } from './en/translation';

export const defaultNS = 'translation';
export const resources = {
  en: {
    translation,
  },
} as const;

i18next.use(initReactI18next).init({
  lng: 'en',
  fallbackLng: 'en',
  returnNull: false,
  debug: process.env.NODE_ENV !== 'production',
  defaultNS,
  resources,
  interpolation: {
    // Unescape special characters in interpolated values
    // React does its own escaping to prevent XSS
    escapeValue: false,
  },
});

// If we change language, we also have to change moment locale and
// include it in the `ContextReplacementPlugin` of `webpack.config.js`
// More details: https://momentjs.com/docs/#/i18n/changing-locale/
moment.locale('en');

export default i18next;
